document.addEventListener("DOMContentLoaded", async function () {
  const form = document.querySelector(".custom-registration-form");
  const steps = form.querySelectorAll(".form-step");
  const stepIndicator = document.querySelector(".step-indicator");
  const progressLine = stepIndicator.querySelector(".progress-line");
  const stepElements = stepIndicator.querySelectorAll(".step");
  const nextButtons = form.querySelectorAll("[data-next]");
  const backButtons = form.querySelectorAll("[data-back]");
  const validateVatButton = form.querySelector('[data-action="validate-vat"]');
  const submitButton = form.querySelector(".submit-button");
  const buttonText = submitButton.querySelector(".button-text");
  const loadingSpinner = submitButton.querySelector(".loading-spinner");
  const countrySelect = document.getElementById("country");
  const addressInput = document.getElementById("address");
  const stateInput = document.getElementById("state");
  const zipInput = document.getElementById("zip");
  const cityInput = document.getElementById("city");
  const phoneInput = document.getElementById("phone");
  const companyNameInput = document.getElementById("companyName");
  const passwordInput = document.getElementById("password");
  const confirmPasswordInput = document.getElementById("confirmPassword");
  const passwordRequirements = document.querySelector(".password-requirements");
  const requirementItems = passwordRequirements.querySelectorAll(".requirement");
  const vatInput = document.getElementById("vatNumber");

  let locationMismatchActive = false;
  let currentStep = 1;
  let formValidation = {
    step1: false,
    step2: false,
    step3: false,
  };
  let countriesData = [];
  let countryMap = new Map();
  let stateMap = new Map();
  let cityMap = new Map();
  let fillingFromSuggestion = false;
  let postcodeIsValid = true;

  const ADDRESS_AUTOCOMPLETE_ENDPOINT = "/apps/api/address/autocomplete";
  let placesSessionToken = null;

  function newSessionToken() {
    if (window.crypto && typeof crypto.randomUUID === "function") {
      return crypto.randomUUID();
    }
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
      const r = (Math.random() * 16) | 0;
      const v = c === "x" ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  }

  function getSupportedCountryCodes() {
    return countriesData.map((c) => c.code).filter(Boolean);
  }

  function safeReviver(key, value) {
    if (typeof value === "string") {
      return value
        .replace(/[\u2018\u2019]/g, "'")
        .replace(/[\u201C\u201D]/g, '"')
        .replace(/[\u2013\u2014]/g, '-')
        .replace(/[\u00A0]/g, ' ')
        .replace(/[\u200B-\u200D\uFEFF\u2028\u2029]/g, '')
        .replace(/[\x00-\x08\x0B\x0C\x0E-\x1F\x7F]/g, '')
        .replace(/\r\n|\r/g, '\n')
        .trim();
    }
    return value;
  }

  async function loadLocationData() {
    try {
      const resp = await fetch(window.countryAssetUrl);
      if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
      const text = await resp.text();
      countriesData = JSON.parse(text, safeReviver);

      countriesData?.forEach(c => {
        countryMap.set(c.code, c);
        c.states?.forEach(s => {
          const stateKey = `${c.code}|${s.name}`;
          stateMap.set(stateKey, s);
          s.cities.forEach(ct => {
            const cityKey = `${c.code}|${s.name}|${ct.name}`;
            cityMap.set(cityKey, ct);
          });
        });
      });

      countrySelect.innerHTML = '<option value="">Select Country</option>';
      countriesData.sort((a, b) => a.name.localeCompare(b.name)).forEach(c => {
        const opt = document.createElement("option");
        opt.value = c.code;
        opt.textContent = c.name;
        countrySelect.appendChild(opt);
      });

      stateInput.innerHTML = '<option value="">Select State</option>';
      cityInput.innerHTML = '<option value="">Select City</option>';
      stateInput.disabled = true;
      cityInput.disabled = true;

      countrySelect.addEventListener("change", () => {
        const code = countrySelect.value;
        const country = countryMap.get(code);
        cityInput.innerHTML = '<option value="">Select City</option>';
        toggleCityField(false);
        if (!country) {
          stateInput.innerHTML = '<option value="">Select State</option>';
          return;
        }
        stateInput.innerHTML = `<option value="">Select ${country?.haveProvince ? country?.provinceKey : "state"}</option>`;
        country.states.sort((a, b) => a.name.localeCompare(b.name)).forEach(s => {
          const opt = document.createElement("option");
          opt.value = s.name;
          opt.textContent = s.name;
          stateInput.appendChild(opt);
        });
        stateInput.disabled = false;
        handleProvinceVisibility(code)
        validateAddressFields(code);
        // Re-evaluate VAT: skip/hide it for exempt countries (e.g. CH, NO) as soon
        // as the country changes, instead of only when clicking Continue.
        toggleVatFieldVisibility();
      });

      stateInput.addEventListener("change", () => {
        const countryCode = countrySelect.value;
        const stateName = stateInput.value;
        const stateKey = `${countryCode}|${stateName}`;
        const state = stateMap.get(stateKey);
        cityInput.innerHTML = '<option value="">Select City</option>';
        cityInput.disabled = true;
        if (state && state.cities.length > 0) {
          state.cities.sort((a, b) => a.name.localeCompare(b.name)).forEach(ct => {
            const opt = document.createElement("option");
            opt.value = ct.name;
            opt.textContent = ct.name;
            cityInput.appendChild(opt);
          });
          cityInput.disabled = false;
          toggleCityField(false);
        } else {
          convertCityToInput('');
        }
        cityInput.dispatchEvent(new Event("input"));
        validateField(cityInput, false);
        validateAddressFields();
        updateStepValidation(currentStep);
      });

      cityInput.addEventListener("change", () => {
        validateAddressFields();
        updateStepValidation(currentStep);
      });

    } catch (e) {
      console.error("Failed to load countries_states_cities.json", e);
      countrySelect.innerHTML = '<option value="">Data unavailable</option>';
      countrySelect.disabled = true;
      stateInput.disabled = true;
      cityInput.disabled = true;
    }
  }

  await loadLocationData();

  // --- VAT requirement configuration ---------------------------------------
  // Single source of truth = the "VAT Validation" theme setting in Shopify
  // (settings.vat_validation_exempt_countries), exposed as
  // window.vatValidationExemptCountries. Business-managed, no code change needed.
  //
  // EVERY entry in the list SKIPS the VAT field (makes it optional), one per line
  // (commas also accepted):
  //   * A country ISO code, e.g. "CH"          -> skip VAT for that whole country.
  //   * A country-province code, e.g. "GB-ENG" -> skip VAT for that province only.
  // Any country/province NOT in the list requires a VAT number. So to make Great
  // Britain optional but keep Northern Ireland required, list GB-ENG, GB-SCT and
  // GB-WLS (leave NIR out). If the setting is empty or fails to load, VAT is
  // required everywhere (safe fail-closed default).
  const _vatSkipRaw =
    typeof window.vatValidationExemptCountries === "string"
      ? window.vatValidationExemptCountries.split(/[\n,]/)
      : Array.isArray(window.vatValidationExemptCountries)
      ? window.vatValidationExemptCountries
      : [];

  const vatSkipCountries = new Set(); // whole-country skips, e.g. "CH", "NO"
  const vatSkipProvinces = new Set(); // province-level skips, e.g. "GB-ENG"
  _vatSkipRaw
    .map((code) => String(code).trim().toUpperCase())
    .filter(Boolean)
    .forEach((code) => {
      if (code.includes("-")) {
        vatSkipProvinces.add(code);
      } else {
        vatSkipCountries.add(code);
      }
    });

  // Returns the ISO 3166-2 province code for the current country + province
  // selection. The province <select> stores the province NAME as its value, so
  // we resolve it back to its code via the loaded country data.
  function getSelectedProvinceCode() {
    const countryCode = (countrySelect.value || "").trim().toUpperCase();
    const country = countryMap.get(countryCode);
    if (!country || !Array.isArray(country.states)) return "";
    const stateName = (stateInput.value || "").trim();
    if (!stateName) return "";
    const match = country.states.find((s) => s.name === stateName);
    return match && match.code ? String(match.code).toUpperCase() : "";
  }

  // True when a country has any province-level skip entry (e.g. GB, because of
  // "GB-ENG"/"GB-SCT"/"GB-WLS"). Such countries must expose the province field so
  // the per-province rule can be evaluated.
  function countryHasProvinceOverride(countryCode) {
    const prefix = (countryCode || "").trim().toUpperCase() + "-";
    for (const entry of vatSkipProvinces) {
      if (entry.startsWith(prefix)) return true;
    }
    return false;
  }

  // Core rule: is a VAT number required for the current country/province selection?
  function isVatRequiredForSelection() {
    const countryCode = (countrySelect.value || "").trim().toUpperCase();
    if (!countryCode) return false;
    // Province-level skip (e.g. GB-ENG) makes VAT optional for that province.
    const provinceCode = getSelectedProvinceCode();
    if (provinceCode && vatSkipProvinces.has(`${countryCode}-${provinceCode}`)) {
      return false;
    }
    // Whole-country skip makes VAT optional.
    if (vatSkipCountries.has(countryCode)) return false;
    // Default: VAT required.
    return true;
  }

  // Handle keydown events on form fields
  form.querySelectorAll("input, select").forEach((field) => {
    field.addEventListener("keydown", function (e) {
      if (
        e.key === "Enter" &&
        this.tagName !== "TEXTAREA" &&
        this.type !== "submit"
      ) {
        e.preventDefault();
      }
    });
  });

  // Password validation rules
  const passwordValidation = {
    length: (value) => value.length >= 8,
    uppercase: (value) => /[A-Z]/.test(value),
    lowercase: (value) => /[a-z]/.test(value),
    number: (value) => /[0-9]/.test(value),
    special: (value) => /[!@#$%^&*(),.?":{}|<>]/.test(value),
  };

  function updateProgressBar(step) {
    // Cap at 100% so the fill never overflows past the last step (e.g. a stray step 4).
    const progress = Math.min(100, Math.max(0, ((step - 1) / (steps.length - 1)) * 100));
    progressLine.style.setProperty("--progress", `${progress}%`);

    stepElements.forEach((stepEl, index) => {
      if (index + 1 < step) {
        stepEl.classList.add("completed");
        stepEl.classList.remove("active");
      } else if (index + 1 === step) {
        stepEl.classList.add("active");
        stepEl.classList.remove("completed");
      } else {
        stepEl.classList.remove("active", "completed");
      }
    });
  }

  // Show password requirements on focus
  [passwordInput, confirmPasswordInput].forEach((input) => {
    input.addEventListener("focus", () => {
      passwordRequirements.classList.add("active");
    });

    input.addEventListener("input", () => {
      passwordRequirements.classList.add("active");
      if (input === passwordInput) {
        validatePasswordRequirements(input.value);
      }
    });
  });

  // Hide error box when user changes any input
  form.querySelectorAll("input, select, textarea").forEach((input) => {
    input.addEventListener("input", () => {
      const errorBox = document.getElementById("formErrorMessage");
      if (errorBox) {
        errorBox.style.display = "none";
        errorBox.textContent = "";
      }
      if (['address', 'country', 'state', 'city', 'city-text', 'zip'].includes(input.id)) {
        validateAddressFields();
      }
    });
  });

  // Hide password requirements when clicking outside
  document.addEventListener("click", (e) => {
    if (
      !passwordInput.contains(e.target) &&
      !confirmPasswordInput.contains(e.target) &&
      !passwordRequirements.contains(e.target)
    ) {
      if (!passwordInput.value) {
        passwordRequirements.classList.remove("active");
      }
    }
  });

  function validatePasswordRequirements(value) {
    let allValid = true;
    requirementItems.forEach((req) => {
      const type = req.dataset.requirement;
      const isValid = passwordValidation[type](value);
      req.classList.toggle("met", isValid);
      if (!isValid) allValid = false;
    });
    return allValid;
  }

  // Create address suggestions dropdown
  const suggestionsContainer = document.querySelector(".address-suggestions");

  let debounceTimer;

  addressInput.addEventListener("input", async function () {
    if (fillingFromSuggestion) {
      return;
    }
    clearTimeout(debounceTimer);
    const rawNew = this.value;
    const query = rawNew.trim();

    if (query.length < 3) {
      suggestionsContainer.innerHTML = "";
      suggestionsContainer.style.display = "none";
      return;
    }

    // Start a Google Places autocomplete session on first keystroke (billing optimisation).
    if (!placesSessionToken) placesSessionToken = newSessionToken();

    debounceTimer = setTimeout(async () => {
      try {
        const response = await fetch(ADDRESS_AUTOCOMPLETE_ENDPOINT, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            type: "suggest",
            input: query,
            countries: getSupportedCountryCodes(),
            sessionToken: placesSessionToken,
          }),
        });

        const data = await response.json();
        const suggestions = Array.isArray(data?.suggestions) ? data.suggestions : [];

        if (suggestions.length > 0) {
          suggestionsContainer.innerHTML = suggestions
            .map((s) => {
              const label = (s.description || "")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;");
              return `
              <div class="suggestion" data-place-id="${s.placeId}">
                ${label}
              </div>
            `;
            })
            .join("");

          suggestionsContainer.style.display = "block";
        } else {
          suggestionsContainer.innerHTML = `
            <div class="addresses-page__no-results-content">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="11" cy="11" r="8"/>
                <path d="M21 21l-4.35-4.35"/>
              </svg>
              <span>No addresses found</span>
            </div>`;
          suggestionsContainer.style.display = "block";
        }
      } catch (error) {
        console.error("Error fetching address suggestions:", error);
      }
    }, 300);
  });

  // Handle suggestion selection — fetch full place details from the proxy, then populate.
  suggestionsContainer.addEventListener("click", async function (e) {
    const suggestion = e.target.closest(".suggestion");

    if (!suggestion) return;
    const placeId = suggestion.dataset.placeId;
    if (!placeId) return;

    suggestionsContainer.style.display = "none";

    let addr = null;
    try {
      const response = await fetch(ADDRESS_AUTOCOMPLETE_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          type: "details",
          placeId: placeId,
          sessionToken: placesSessionToken,
        }),
      });
      const data = await response.json();
      addr = data && data.address ? data.address : null;
    } catch (error) {
      console.error("Error fetching address details:", error);
      addr = null;
    } finally {
      placesSessionToken = null;
    }

    if (!addr) return;
    applyAddressToForm(addr);
  });

  function applyAddressToForm(addr) {
    fillingFromSuggestion = true;

    addressInput.value = addr.street || "";
    zipInput.value = addr.postcode || "";
    countrySelect.value = addr.country || "";
    let selectedStateName = null;
    const iso2 = addr.country;
    const apiState = addr.state;
    const apiCity = addr.city;
    const isoLvl4 = addr.iso;

    if (iso2 && countryMap.has(iso2)) {
      countrySelect.value = iso2;
      countrySelect.dispatchEvent(new Event("change"));
      handleProvinceVisibility(iso2)
      const country = countryMap.get(iso2);
      if (!country) { fillingFromSuggestion = false; return; }
      // Keep the province field in play for countries with a VAT province override
      // (e.g. GB), so an autocompleted Northern Ireland address can still resolve
      // its province and trigger the VAT-required rule.
      if (country.haveProvince === false && !countryHasProvinceOverride(iso2)) {
        const stateWrapper = stateInput.closest(".field");
        stateWrapper.style.display = "none";
        convertCityToInput(apiCity);
        suggestionsContainer.style.display = "none";
        fillingFromSuggestion = false;
        validateAddressFields();
        updateStepValidation(currentStep);
        return;
      }
      handleProvinceVisibility(iso2);
      if (isoLvl4 && isoLvl4.includes('-')) {
        const stateCode = isoLvl4.split('-')[1];
        const matchedState = country.states.find(st => st.code && st.code.toUpperCase() === stateCode.toUpperCase());
        if (matchedState) {
          selectedStateName = matchedState.name;
          stateInput.value = matchedState.name;
          stateInput.dispatchEvent(new Event("change"));
        }
      }

      if (!selectedStateName && apiState) {
        let bestMatch = null;
        let bestScore = 0;
        country.states.forEach(st => {
          const score = wordMatch(apiState, st.name);
          if (score > bestScore && score >= 0.8) {
            bestScore = score;
            bestMatch = st;
          }
        });
        if (bestMatch) {
          selectedStateName = bestMatch.name;
          stateInput.value = bestMatch.name;
          stateInput.dispatchEvent(new Event("change"));
        }
      }

      if (apiCity && selectedStateName) {
        const stateKey = `${iso2}|${selectedStateName}`;
        const state = stateMap.get(stateKey);
        if (state) {
          const exact = state.cities.find(ct => ct.name.toLowerCase() === apiCity.toLowerCase());
          if (exact) {
            cityInput.value = exact.name;
            toggleCityField(false);
          } else {
            let bestCity = null;
            let bestScore = 0;
            state.cities.forEach(ct => {
              const score = wordMatch(apiCity, ct.name);
              if (score > bestScore && score >= 0.8) {
                bestScore = score;
                bestCity = ct;
              }
            });
            if (bestCity) {
              cityInput.value = bestCity.name;
              toggleCityField(false);
            }
          }
        }
      }
    }
    suggestionsContainer.style.display = "none";
    setTimeout(() => { fillingFromSuggestion = false; }, 0);

    [addressInput, cityInput, zipInput, countrySelect, stateInput].forEach((input) => {
      input.dispatchEvent(new Event("input"));
      validateField(input, false);
    });

    validateAddressFields();
    updateStepValidation(currentStep);
  }

  function handleProvinceVisibility(countryCode) {
    const country = countryMap.get(countryCode);
    if (!country) return;
    const stateWrapper = stateInput.closest(".field");
    const cityTextInput = document.getElementById('city-text');
    const existingCity = cityTextInput?.value || cityInput.value || '';
    // Countries with a province-level VAT override (e.g. GB, for Northern Ireland)
    // must expose the province field even if the data marks haveProvince=false,
    // otherwise the customer could never select the province the rule depends on.
    if (country.haveProvince === false && !countryHasProvinceOverride(countryCode)) {
      stateWrapper.style.display = "none";
      stateInput.removeAttribute("required");
      convertCityToInput(existingCity);
      return;
    }
    stateWrapper.style.display = "";
    stateInput.setAttribute("required", "required");
    const stateLabel = stateWrapper.querySelector("label");
    stateLabel.textContent = country.provinceKey
      ? `Select ${country.provinceKey}`
      : "Select State";
    toggleCityField(false);
    cityInput.innerHTML = '<option value="">Select City</option>';
  };

  function convertCityToInput(cityName) {
    const fieldWrapper = cityInput.closest('.field');
    let cityTextInput = fieldWrapper.querySelector('#city-text');

    if (cityInput.style.display === 'none' && cityTextInput) {
      cityTextInput.value = cityName ? cityName.trim() : '';
      cityTextInput.dispatchEvent(new Event("input"));
      return;
    }

    toggleCityField(true);

    if (!cityTextInput) {
      cityTextInput = document.createElement("input");
      cityTextInput.type = "text";
      cityTextInput.id = "city-text";
      cityTextInput.name = "city";
      cityTextInput.className = "field-input";
      cityTextInput.required = true;
      cityTextInput.placeholder = "Enter city";
      cityTextInput.maxLength = 100;
      cityTextInput.value = cityName ? cityName.trim() : '';
      fieldWrapper.insertBefore(cityTextInput, cityInput);
      
      cityTextInput.addEventListener("input", () => {
        validateField(cityTextInput);
        validateAddressFields();
        updateStepValidation(currentStep);
      });
      cityTextInput.addEventListener("blur", () => validateField(cityTextInput));
    } else {
      cityTextInput.value = cityName ? cityName.trim() : '';
    }

    window.cityInput = cityTextInput;
    cityTextInput.dispatchEvent(new Event("input"));
  }

  function toggleCityField(showInput) {
    const fieldWrapper = cityInput.closest('.field');
    const cityTextInput = fieldWrapper.querySelector('#city-text');

    if (showInput) {
      cityInput.style.display = 'none';
      cityInput.removeAttribute('required');
      if (cityTextInput) {
        cityTextInput.style.display = 'block';
        cityTextInput.setAttribute('required', 'required');
      }
    } else {
      cityInput.style.display = 'block';
      cityInput.setAttribute('required', 'required');
      if (cityTextInput) {
        cityTextInput.style.display = 'none';
        cityTextInput.removeAttribute('required');
      }
    }
  }

  document.addEventListener("click", function (e) {
    if (
      !e.target.closest(".address-suggestions") &&
      !e.target.closest("#address")
    ) {
      suggestionsContainer.style.display = "none";
    }
  });

  addressInput.addEventListener("keydown", function (e) {
    if (e.key === "Enter") {
      e.preventDefault();
      const firstSuggestion = suggestionsContainer.querySelector(".suggestion");
      if (firstSuggestion) {
        firstSuggestion.click();
      }
    }
  });

  function validateAddressFields() {
    const stepElement = steps[1];
    const errorElement = stepElement.querySelector('.inline-error-message');
    const nextBtn = stepElement.querySelector("[data-next]") || submitButton;
    const countryCode = countrySelect.value.trim().toUpperCase();
    const zipCode = zipInput.value.trim();
    let msg = "";
    postcodeIsValid = true;
      if (postcodeIsValid && countryCode && zipCode && typeof window.validatePostcode === "function") {
        try {
          const valid = window.validatePostcode(zipCode, countryCode);
          if (!valid) {
            msg = getErrorText("custom_postal_code");
            postcodeIsValid = false;
          }
        } catch (e) {
          console.error("postcode validation error:", e);
        }
      }
    if (errorElement) {
      errorElement.textContent = msg;
      errorElement.style.display = msg ? "block" : "none";
    }
    const stepValid = validateStep(2, false);
    const finalValid = stepValid && postcodeIsValid;
    if (nextBtn) nextBtn.disabled = false; // always enabled; validated on click
    formValidation.step2 = finalValid;
    if (currentStep === 2) updateStepValidation(currentStep);
  }
  
  function wordMatch(apiName, jsonName) {
    if (!apiName || !jsonName) return 0;
    const apiWords = apiName.toLowerCase().replace(/[^\w\s]/g, '').split(/\s+/).filter(Boolean);
    const jsonWords = jsonName.toLowerCase().replace(/[^\w\s]/g, '').split(/\s+/).filter(Boolean);
    if (apiWords.length === 0) return 0;
    let matchCount = 0;
    apiWords.forEach(word => {
      if (jsonWords.some(jw => jw.includes(word) || word.includes(jw))) matchCount++;
    });
    return matchCount / apiWords.length;
  }

  // Real-time validation
  form.querySelectorAll(".field-input").forEach((input) => {
    input.addEventListener("input", () => {
      validateField(input, false);
      updateStepValidation(currentStep);
    });

    input.addEventListener("blur", () => {
      validateField(input, false);
      updateStepValidation(currentStep);
    });
  });

  // Phone Number field: allow digits and phone punctuation only ( + - ( ) space ).
  // Letters and other characters are stripped as the user types / pastes.
  if (phoneInput) {
    phoneInput.addEventListener("input", () => {
      const cleaned = phoneInput.value.replace(/[^0-9+\-()\s]/g, "");
      if (cleaned !== phoneInput.value) {
        const pos = phoneInput.selectionStart - (phoneInput.value.length - cleaned.length);
        phoneInput.value = cleaned;
        try { phoneInput.setSelectionRange(pos, pos); } catch (e) {}
      }
    });
    phoneInput.addEventListener("keypress", (e) => {
      if (e.key && e.key.length === 1 && /[^0-9+\-()\s]/.test(e.key)) e.preventDefault();
    });
  }

  // Terms & Conditions checkbox gates Step 1 (Figma design)
  const agreeTermsCheckbox = document.getElementById("agreeTerms");
  if (agreeTermsCheckbox) {
    agreeTermsCheckbox.addEventListener("change", () => { validateTerms(false); updateStepValidation(currentStep); });
  }

  /**
   * Calls the backend (App Proxy) to validate that company / address fields
   * are within the PostNL 35-character limit.
   *
   * @param {Object} fields  e.g. { company: '...', address1: '...' }
   * @returns {Promise<boolean>}  true → OK to proceed; false → error shown
   */
  function checkLengthBeforeNext(fields) {
    const MAX_LEN = 35;
    const FIELD_LABELS = { company: 'Company name', address1: 'Address line 1', address2: 'Address line 2' };
    const fieldIdMap = {
      company:  currentStep === 1 ? 'companyName' : 'registeredCompanyName',
      address1: 'address',
      address2: 'address2',
    };
    let ok = true;
    for (const [key, value] of Object.entries(fields)) {
      if (value && value.length > MAX_LEN) {
        const label = FIELD_LABELS[key] || key;
        const fieldEl = document.getElementById(fieldIdMap[key] || key);
        if (fieldEl) {
          const errorEl = fieldEl.closest('.field')?.querySelector('.error-message');
          fieldEl.classList.add('error');
          fieldEl.classList.remove('validated');
          if (errorEl) {
            errorEl.textContent = `${label} must be ${MAX_LEN} characters or fewer (currently ${value.length}).`;
            errorEl.style.display = 'block';
          }
        }
        ok = false;
      }
    }
    return ok;
  }

  async function checkAddressBeforeNext() {
    const fieldWrapper = document.querySelector("#address").closest(".field");
    const addressInput = fieldWrapper.querySelector("#address");
    const errorMessage = fieldWrapper.querySelector(".error-message");
    const country = document.querySelector("#country").value;
    const city = document.querySelector("#city").value;
    const cityText = document.querySelector("#city-text")?.value;
    const zip = document.querySelector("#zip").value;
    const address = addressInput.value;
    const company = document.getElementById('registeredCompanyName')?.value?.trim() || '';
    const address2 = document.getElementById('address2')?.value?.trim() || '';

    try {
      const response = await fetch('/apps/api/address/validate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          address: {
            company,
            address1: address,
            address2,
            city: city || cityText || '',
            zip,
            countryCode: country,
          },
        }),
      });
      if (!response.ok) return true; // fail open
      const data = await response.json();
      if (!data.valid && Array.isArray(data.errors) && data.errors.length > 0) {
        const fieldIdMap = { company: 'registeredCompanyName', address1: 'address', address2: 'address2' };
        for (const err of data.errors) {
          const domId = fieldIdMap[err.field] || 'address';
          const el = document.getElementById(domId);
          if (el) {
            const errEl = el.closest('.field')?.querySelector('.error-message');
            el.classList.add('error');
            el.classList.remove('validated');
            if (errEl) { errEl.textContent = err.message; errEl.style.display = 'block'; }
          } else {
            errorMessage.style.display = "block";
            errorMessage.textContent = err.message;
          }
        }
        return false;
      }
      errorMessage.style.display = "none";
      errorMessage.textContent = "";
      return true;
    } catch (e) {
      console.warn('[checkAddressBeforeNext] request failed, failing open:', e);
      return true;
    }
  };

  function validateField(field, showError = false) {
    let isValid = true;
    let errorMessage = '';
  
    const getFieldLabel = (field) => {
      const label = field.closest('.field')?.querySelector('label');
      return label ? label.textContent.replace(' *', '') : 'This field';
    };
  
    if (field.id === 'vatNumber') {
      const isExempt = !isVatRequiredForSelection();
      const vatWrapper = field.closest('.field');
    
      const isVisible = vatWrapper && vatWrapper.offsetParent !== null;
    
      if (!isExempt && isVisible) {
        if (!field.value) {
          const label = getFieldLabel(field);
          const isHiddenSelect = field.tagName === 'SELECT' && (field.style.display === 'none' || field.offsetParent === null);
          const skipValidation = isHiddenSelect;

          if (!skipValidation) {
            isValid = false;
            errorMessage = `${label} is required`;
          }
        } else if (field.dataset.validated !== 'true') {
          isValid = false;
          errorMessage = 'Please enter a valid VAT number';
        }
      } else {
        isValid = true;
        field.dataset.validated = 'true';
      }
    
      if (isValid) {
        field.classList.add('validated');
      } else {
        field.classList.remove('validated');
      }

      const errorElement = field.closest('.field').querySelector('.error-message');
      if (showError) {
        field.classList.toggle('error', !isValid);
        if (errorElement) {
          errorElement.textContent = errorMessage;
          errorElement.style.display = !isValid ? 'block' : 'none';
        }
      } else if (isValid) {
        field.classList.remove('error');
        if (errorElement) {
          errorElement.textContent = '';
          errorElement.style.display = 'none';
        }
      }

      return { isValid, errorMessage };
    }
  
    if (field.required && !field.value.trim()) {
      const label = getFieldLabel(field);
      const isHiddenSelect = field.tagName === 'SELECT' && (field.style.display === 'none' || field.offsetParent === null);
      const skipValidation = isHiddenSelect;

      if (!skipValidation) {
        isValid = false;
        errorMessage = `${label} is required`;
      }
    } else if (field.type === 'email' && field.value) {
      isValid = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(field.value.trim());
      if (!isValid) errorMessage = 'Please enter a valid email address';
    } else if (field.id === 'phone' && field.value) {
      var phoneDigits = field.value.replace(/[\s\-().]/g, '');
      isValid = /^\d{6,15}$/.test(phoneDigits);
      if (!isValid) errorMessage = 'Please enter a valid phone number';
    } else if (field.id === 'password' && field.value) {
      isValid = validatePasswordRequirements(field.value);
      if (!isValid) errorMessage = 'Password does not meet requirements';
    } else if (field.id === 'confirmPassword') {
      const password = document.getElementById("password");
      isValid = field.value === password.value;
      if (!isValid) errorMessage = 'Passwords do not match';
    }

    // PostNL / carrier 35-character line limit — client-side real-time check.
    // The backend (proxy.address.length) performs the authoritative check on Continue.
    const LENGTH_LIMITED_IDS = ['companyName', 'registeredCompanyName', 'address'];
    const MAX_FIELD_LEN = 35;
    if (isValid && LENGTH_LIMITED_IDS.includes(field.id) && field.value.trim().length > MAX_FIELD_LEN) {
      isValid = false;
      errorMessage = `This field must be ${MAX_FIELD_LEN} characters or fewer (currently ${field.value.trim().length}).`;
    }

    if (isValid && field.value) {
      field.classList.add('validated');
    } else {
      field.classList.remove('validated');
    }

    const errorElement = field.closest('.field').querySelector('.error-message');
    if (showError) {
      field.classList.toggle('error', !isValid);
      if (errorElement) {
        errorElement.textContent = errorMessage;
        errorElement.style.display = !isValid ? 'block' : 'none';
      }
    } else if (isValid) {
      field.classList.remove('error');
      if (errorElement) {
        errorElement.textContent = '';
        errorElement.style.display = 'none';
      }
    }

    return { isValid, errorMessage };
  }

  function validateStep(step, showErrors = false) {
    const stepElement = steps[step - 1];
    const fields = stepElement.querySelectorAll(".field-input[required]");
    let isValid = true;

    fields.forEach((field) => {
      const validation = validateField(field, showErrors);
      if (!validation.isValid) {
        isValid = false;
      }
    });

    return isValid;
  }

  // Terms & Conditions checkbox (step 1). Shows an inline error only when showError is true.
  function validateTerms(showError) {
    const terms = document.getElementById("agreeTerms");
    const errorEl = document.getElementById("agreeTermsError");
    const ok = !!(terms && terms.checked);
    if (errorEl) errorEl.textContent = (!ok && showError) ? "Please accept the Terms and Conditions to continue." : "";
    return ok;
  }

  function updateStepValidation(step) {
    const stepElement = steps[step - 1];
    const nextButton = stepElement.querySelector("[data-next]") || submitButton;
    const isStepValid = validateStep(step, false);
    let finalValid = (step !== 2) ? isStepValid : (isStepValid && postcodeIsValid);
    // Step 1 also requires the Terms & Conditions checkbox (Figma design)
    if (step === 1) {
      const terms = document.getElementById("agreeTerms");
      if (terms && !terms.checked) finalValid = false;
    }
    formValidation[`step${step}`] = finalValid;
    // Button stays ALWAYS enabled; fields are checked on click instead.
    nextButton.disabled = false;
  }

  function showStep(stepNumber) {
    // Never move outside the real step range. Guards against a blank/broken state
    // (all panels hidden, progress overflowing) if something asks for a step 4.
    stepNumber = Math.max(1, Math.min(stepNumber, steps.length));
    steps.forEach((step, index) => {
      step.style.display = index + 1 === stepNumber ? "block" : "none";
    });

    updateProgressBar(stepNumber);
    currentStep = stepNumber;
    updateStepValidation(stepNumber);
  }

  function getVatPrefix(iso2) {
    const code = (iso2 || "").toUpperCase();
    const special = { GR: "EL" };
    return special[code] || code;
  }

  function getErrorText(key) {
    const el = document.querySelector(`#error-translations [data-error="${key}"]`);
    return el ? el.textContent.trim() : "";
  }
  
  // Fetch VAT details directly from the public API (client-side).
  async function fetchVatDetails(vat) {
    const r = await fetch(
      "https://controleerbtwnummer.eu/api/validate/" + vat + ".json"
    );
    return await r.json();
  }

  // Validate the VAT number (auto-fetch). Country can come from the leading
  // 2 letters of the VAT input (e.g. NL...) or from the selected Country field.
  async function runVatValidation() {
    const vatInput = document.getElementById("vatNumber");
    if (!vatInput) return;
    const errorElement = vatInput.closest(".field").querySelector(".error-message");
    const raw = vatInput.value.trim();

    vatInput.classList.remove("error", "validated");
    vatInput.dataset.validated = "false";
    if (errorElement) { errorElement.textContent = ""; errorElement.style.display = "none"; }

    if (!raw) return; // empty: let step validation handle "required" on Continue

    // Determine the country prefix
    let prefix = "";
    let number = raw;
    const leading = raw.match(/^([A-Za-z]{2})/);
    if (leading) {
      prefix = getVatPrefix(leading[1]);
      number = raw.slice(2);
    } else {
      prefix = getVatPrefix((countrySelect.value || "").toUpperCase());
    }
    // Not enough info to check yet (no prefix in input and no country picked) — wait quietly
    if (!prefix) return;

    number = number.replace(/[^A-Za-z0-9]/g, "");
    if (!number) return;

    const vatWrap = vatInput.closest(".vat-input-wrap");
    vatInput.classList.add("validating");
    if (vatWrap) vatWrap.classList.add("loading");
    try {
      const data = await fetchVatDetails(prefix + number);

      if (data.valid) {
        vatInput.classList.remove("error");
        vatInput.classList.add("validated");
        vatInput.dataset.validated = "true";
        if (errorElement) { errorElement.textContent = ""; errorElement.style.display = "none"; }
        autofillFromVat(data);
        updateStepValidation(currentStep);
      } else {
        vatInput.classList.add("error");
        vatInput.classList.remove("validated");
        vatInput.dataset.validated = "false";
        if (errorElement) { errorElement.textContent = "Invalid VAT number"; errorElement.style.display = "block"; }
      }
    } catch (error) {
      console.error("VAT validation error:", error);
      vatInput.classList.add("error");
      vatInput.classList.remove("validated");
      vatInput.dataset.validated = "false";
      if (errorElement) { errorElement.textContent = "Error validating VAT number. Please try again."; errorElement.style.display = "block"; }
    } finally {
      vatInput.classList.remove("validating");
      if (vatWrap) vatWrap.classList.remove("loading");
    }
  }

  // Auto-fill company + address fields from the VAT validation response.
  function autofillFromVat(data) {
    const addr = (data && data.address) || {};
    const setVal = (el, v) => {
      if (el && v != null && String(v).trim() !== "") { el.value = String(v).trim(); }
    };

    // Company name → both the step-2 registered name and any #companyName field
    if (data && data.name) {
      setVal(document.getElementById("registeredCompanyName"), data.name);
      setVal(companyNameInput, data.name);
    }

    // Address line = street + house number (strip leading zeros: "00034" -> "34")
    const houseNo = String(addr.number || "").replace(/^0+(?=\d)/, "");
    const line = [addr.street, houseNo].filter(Boolean).join(" ").replace(/\s+/g, " ").trim();
    if (line) {
      fillingFromSuggestion = true; // suppress the address autocomplete popup
      setVal(addressInput, line);
    }

    // Postal code
    if (addr.zip_code) setVal(zipInput, String(addr.zip_code).replace(/\s+/g, ""));

    // Country select → set value if the option exists, then run the cascade
    if (addr.countryCode && countrySelect) {
      const cc = addr.countryCode.toUpperCase();
      const opt = Array.from(countrySelect.options).find(
        (o) => (o.value || "").toUpperCase() === cc
      );
      if (opt) {
        countrySelect.value = opt.value;
        countrySelect.dispatchEvent(new Event("change"));
      }
    }

    // City → set as free text (works whether the city field is a select or a text input)
    if (addr.city) {
      try {
        convertCityToInput(addr.city);
      } catch (e) {}
      const cityText = document.getElementById("city-text");
      if (cityText) setVal(cityText, addr.city);
      else setVal(cityInput, addr.city);
    }

    // Re-validate the filled fields and refresh the step / Continue button state
    [
      companyNameInput,
      document.getElementById("registeredCompanyName"),
      addressInput,
      zipInput,
      cityInput,
      document.getElementById("city-text"),
      countrySelect,
    ].forEach((el) => {
      if (!el) return;
      try { validateField(el, false); } catch (e) {}
    });
    if (zipInput) zipInput.dispatchEvent(new Event("input"));
    try { validateAddressFields(); } catch (e) {}
    setTimeout(() => { fillingFromSuggestion = false; }, 0);
    updateStepValidation(currentStep);
  }

  // Keep the button working if it still exists on the page
  if (validateVatButton) {
    validateVatButton.addEventListener("click", runVatValidation);
  }

  // Auto-validate the VAT number when the user stops typing (debounced)
  (function () {
    const vatEl = document.getElementById("vatNumber");
    if (!vatEl) return;
    let vatTimer;
    vatEl.addEventListener("input", function () {
      clearTimeout(vatTimer);
      // reset validated state while editing
      vatEl.dataset.validated = "false";
      vatEl.classList.remove("validated", "error");
      const errEl = vatEl.closest(".field") && vatEl.closest(".field").querySelector(".error-message");
      if (errEl) { errEl.textContent = ""; errEl.style.display = "none"; }
      vatTimer = setTimeout(runVatValidation, 700);
    });
    // also validate on blur (leaving the field) in case they paste and click away fast
    vatEl.addEventListener("blur", function () {
      clearTimeout(vatTimer);
      runVatValidation();
    });
  })();

  nextButtons.forEach((button) => {
    button.addEventListener("click", async () => {
      // Step 2 safety net: if the VAT field has a value but isn't validated yet
      // (e.g. the user navigated back/forward without re-touching it), run the
      // VAT check here on Continue so a valid VAT isn't wrongly flagged.
      if (currentStep === 2) {
        const vatField = document.getElementById('vatNumber');
        const vatWrapper = vatField ? vatField.closest('.field') : null;
        const vatVisible = vatWrapper && vatWrapper.offsetParent !== null;
        if (vatField && vatVisible && !isExemptCountrySelected() && vatField.value.trim() && vatField.dataset.validated !== 'true') {
          await runVatValidation();
        }
      }
      // Validate the current step's fields on click (shows errors on the wrong ones).
      const stepValid = validateStep(currentStep, true);
      // Step 1 also requires the Terms & Conditions checkbox.
      const termsOk = currentStep === 1 ? validateTerms(true) : true;
      if (!stepValid || !termsOk) return;

      // ── 35-character backend length check (PostNL / carrier constraint) ──────
      if (currentStep === 1) {
        // Step 1 → 2: validate company name length via backend
        const companyVal = document.getElementById('companyName')?.value?.trim() || '';
        if (companyVal) {
          const lengthOk = checkLengthBeforeNext({ company: companyVal });
          if (!lengthOk) return;
        }
      }
      if (currentStep === 2) {
        // Step 2 → 3: validate registered company name + address length via backend
        const regCompanyVal = document.getElementById('registeredCompanyName')?.value?.trim() || '';
        const addrVal       = document.getElementById('address')?.value?.trim()               || '';
        const fieldsToCheck = {};
        if (regCompanyVal) fieldsToCheck.company  = regCompanyVal;
        if (addrVal)       fieldsToCheck.address1 = addrVal;
        if (Object.keys(fieldsToCheck).length > 0) {
          const lengthOk = checkLengthBeforeNext(fieldsToCheck);
          if (!lengthOk) return;
        }
      }
      // ── end length check ──────────────────────────────────────────────────────

      if (currentStep === 2) {
        const ok = await checkAddressBeforeNext();
        if (!ok) return; // keep the button enabled; the address error is already shown
        toggleVatFieldVisibility();
      }
      showStep(currentStep + 1);
    });
  });

  backButtons.forEach((button) => {
    button.addEventListener("click", () => {
      showStep(currentStep - 1);
    });
  });

  function toggleVatFieldVisibility() {
    const vatField = document.getElementById('vatNumber');
    const vatWrapper = vatField.closest('.field');
    const isExempt = isExemptCountrySelected();
    // Chamber of Commerce shares the VAT row: make it full-width when VAT is hidden.
    const cocWrapper = document.getElementById('chamberOfCommerce')?.closest('.field');

    if (isExempt) {
      vatWrapper.style.display = 'none';
      vatField.removeAttribute('required');
      vatField.dataset.validated = 'true';
      if (cocWrapper) cocWrapper.classList.remove('half-width');
    } else {
      vatWrapper.style.display = '';
      vatField.setAttribute('required', 'required');
      if (cocWrapper) cocWrapper.classList.add('half-width');
      // Preserve an already-validated VAT so navigating back/forward doesn't
      // wrongly invalidate it. Only reset when the field is empty (fresh entry).
      if (!vatField.value.trim()) {
        vatField.dataset.validated = 'false';
        vatField.classList.remove('validated', 'error');
      }
    }

    updateStepValidation(currentStep);
  }

  // A country/province is "exempt" (VAT optional) when it is NOT required by the
  // config - i.e. any non-EU country, and GB provinces other than Northern Ireland.
  function isExemptCountrySelected() {
    return !isVatRequiredForSelection();
  }

  // ---------------------------------------------------------------------------
  // Registration success screen
  //
  // Markup and copy live in sections/main-register.liquid so the client can edit
  // the wording in the theme customiser. This only swaps the form out for the
  // success panel and reveals the Rixus block when the app says the customer is
  // eligible. No discount logic here - SELLY owns that.
  // ---------------------------------------------------------------------------
  function showRegistrationSuccess(rixusEligible) {
    var panel = document.getElementById("registrationSuccess");

    // Defensive: if the section was not updated (older theme copy), fall back to
    // the previous behaviour so registration never dead-ends on a blank screen.
    if (!panel) {
      window.location.href = "/account";
      return;
    }

    if (rixusEligible) {
      var promoBlock = panel.querySelector("[data-promo-block]");
      if (promoBlock) promoBlock.hidden = false;
    }

    // The success panel carries its own heading, so the "Create account" title,
    // the step indicator, the form and the footer all come off the page.
    var formTitle = document.querySelector(".form-title");
    var stepIndicator = document.querySelector(".step-indicator");
    var formFooter = document.querySelector(".form-footer");
    if (formTitle) formTitle.hidden = true;
    if (stepIndicator) stepIndicator.hidden = true;
    if (formFooter) formFooter.hidden = true;
    form.hidden = true;

    panel.hidden = false;
    panel.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  form.addEventListener("submit", async function (e) {
    e.preventDefault();

    if (!validateStep(currentStep, true)) {
      return;
    }

    try {
      const errorBox = document.getElementById("formErrorMessage");
      if (errorBox) {
        errorBox.style.display = "none";
        errorBox.textContent = "";
      }
    
      buttonText.textContent = "Creating Account...";
      loadingSpinner.style.display = "inline-block";
      submitButton.disabled = true;
    
      // Phone: prepend the selected country dial code so the full international number is stored
      const phoneCountryCodeEl = document.getElementById("phoneCountryCode");
      const dialCode = phoneCountryCodeEl ? (phoneCountryCodeEl.value || "").trim() : "";
      const rawPhone = document.getElementById("phone").value.trim();
      const fullPhone = dialCode ? (dialCode + " " + rawPhone).trim() : rawPhone;
      // Terms & Conditions consent
      const agreeTermsEl = document.getElementById("agreeTerms");
      const termsAccepted = agreeTermsEl ? agreeTermsEl.checked : false;
      // Registered location (radio) + registered/legal company name
      const regLocEl = document.querySelector('input[name="regloc"]:checked');
      const registeredLocation = regLocEl ? regLocEl.value : "";
      const registeredCompanyNameEl = document.getElementById("registeredCompanyName");
      const registeredCompanyName = registeredCompanyNameEl ? registeredCompanyNameEl.value : "";

      const payload = {
        email: document.getElementById("email").value,
        password: document.getElementById("password").value,
        name: `${document.getElementById("firstName").value} ${document.getElementById("lastName").value}`,
        first_name: document.getElementById("firstName").value,
        last_name: document.getElementById("lastName").value,
        address: {
          company: registeredCompanyName,
          address1: document.getElementById("address").value,
          city: document.getElementById("city-text")?.value || document.getElementById("city").value,
          zip: document.getElementById("zip").value,
          country: document.getElementById("country").value,
          state: document.getElementById("state-text")?.value || document.getElementById("state").value,
          phone: fullPhone,
        },
        phone: fullPhone,
        accepts_marketing: document.getElementById("newsletter").checked,
        custom: {
          phone: fullPhone,
          phone_country_code: dialCode,
          company_name: document.getElementById("companyName").value,
          vat: document.getElementById("vatNumber").value,
          coc: document.getElementById("chamberOfCommerce").value,
          number_of_stores: document.getElementById("numberOfStores").value,
          estimated_monthly_value: document.getElementById("monthlyPurchaseVolume").value,
          main_activity: document.getElementById("mainActivity") ? document.getElementById("mainActivity").value : "",
          registered_company_name: registeredCompanyName,
          registered_location: registeredLocation,
          terms_accepted: termsAccepted
        },
        tags: "customer_registered",
      };
    
      // Send the request
      const response = await fetch("/apps/api/customer/register", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });
    
      const responseData = await response.json();
      if (!response.ok) {
        const errorMessage = responseData?.error || "Registration failed. Please try again.";
        if (errorBox) {
          errorBox.textContent = errorMessage;
          errorBox.style.display = "block";
          errorBox.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        return;
      }
      showRegistrationSuccess(responseData && responseData.rixusFirstOrderEligible === true);
      // Show the Figma thank-you screen instead of an alert + redirect.
      // The panel's real id is "registrationSuccess" (main-register.liquid),
      // and it is shown/hidden via the "hidden" attribute — the section's CSS
      // makes [hidden] authoritative with !important, so toggling inline
      // style.display alone has no effect while the attribute is still set.
      const formInner = document.querySelector(".mr-fig__form-inner");
      const thanksEl = document.getElementById("registrationSuccess");
      if (formInner && thanksEl) {
        formInner.style.display = "none";
        thanksEl.hidden = false;
        thanksEl.scrollIntoView({ behavior: "smooth", block: "center" });
      } else {
        window.location.href = "/account";
      }
    } catch (error) {
      console.error("Registration error:", error);
      const errorBox = document.getElementById("formErrorMessage");
      if (errorBox) {
        errorBox.textContent = "Error creating account. Please try again.";
        errorBox.style.display = "block";
        errorBox.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    } finally {
      buttonText.textContent = "Register as a buyer";
      loadingSpinner.style.display = "none";
      submitButton.disabled = false;
    }
  });

  async function fetchAddressGoogleValidation (address, country, city, zip) {
    try {
      const queryPayload = {
        address: {
          addressLines: [address],
          regionCode: country,
          languageCode: "en",
          postalCode: zip,
          locality: city
        }
      };
      // Call backend endpoint instead of Google API directly to avoid exposing API key
      const response = await fetch('/apps/api/address/validate', {
        method: 'POST',
        body: JSON.stringify(queryPayload),
        headers: {
          'content-type': 'application/json',
        },
      });
      if (response.status === 200) {
        const data = await response.json();
        return data;
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error while getting address validation:', error);
      return []
    }
  };

  function validateGoogleAddress(response, selectedCountry, selectedCity, selectedZip) {
    // ---------------------------------------------------------------------------
    // Address verdict logic.
    //
    // IMPORTANT: do NOT go back to requiring a CONFIRMED "route" component.
    // Large parts of Europe (rural Croatia, Ireland, Nordics, the Balkans, many
    // Greek and Portuguese villages) have addresses with NO street name at all --
    // the settlement name plus a house number IS the complete, deliverable
    // address. For those, Google returns missingComponentTypes: ["route"] and
    // possibleNextAction: "FIX", yet still geocodes the address to an exact
    // building (validationGranularity / geocodeGranularity = "PREMISE").
    // Example that used to be wrongly rejected:
    //   "Gornji Cerovac 116, 47240 Slunj, Croatia"  -> PREMISE / PREMISE, no route.
    //
    // So the accept/reject decision is driven by GRANULARITY (did Google find the
    // building?) and by SUSPICIOUS components (does Google actively contradict the
    // customer?) -- not by the mere presence of a street name.
    // ---------------------------------------------------------------------------
    if (!response || !response.result || !response.result.verdict) {
      // Country outside Google's coverage -> we cannot validate, so don't block.
      if (response && response.error && response.error.message &&
          response.error.message.indexOf("Unsupported region code") !== -1) {
        return { valid: true, message: "" };
      }
      return { valid: false, message: getErrorText("invalid_address") };
    }

    const result     = response.result;
    const verdict    = result.verdict || {};
    const addressObj = result.address || {};
    const components = addressObj.addressComponents || [];

    // 1. Google could make no sense of this at all.
    if (verdict.possibleNextAction === "REJECT") {
      return { valid: false, message: getErrorText("invalid_address") };
    }

    // --- helpers ---------------------------------------------------------------
    // A type can appear more than once. The Croatian sample returns TWO localities
    // ("Gornji Cerovac" CONFIRMED and "Slunj" UNCONFIRMED_BUT_PLAUSIBLE), so pick
    // the best-confirmed one instead of whichever happens to come first.
    const RANK = {
      CONFIRMED: 3,
      UNCONFIRMED_BUT_PLAUSIBLE: 2,
      UNCONFIRMED_AND_SUSPICIOUS: 1
    };
    const allOf = function () {
      const types = Array.prototype.slice.call(arguments);
      return components.filter(function (c) { return types.indexOf(c.componentType) !== -1; });
    };
    const bestOf = function () {
      return allOf.apply(null, arguments).sort(function (a, b) {
        return (RANK[b.confirmationLevel] || 0) - (RANK[a.confirmationLevel] || 0);
      })[0];
    };
    // Google only actively doubts a component when it is UNCONFIRMED_AND_SUSPICIOUS.
    // UNCONFIRMED_BUT_PLAUSIBLE means "looks right, I just have no data to prove
    // it" -- which is the normal answer for a rural house number.
    const trusted = function (c) {
      return !!c && c.confirmationLevel !== "UNCONFIRMED_AND_SUSPICIOUS";
    };
    const norm = function (s) {
      return (s == null ? "" : String(s)).toUpperCase().replace(/[\s\-\.]/g, "");
    };
    const textOf = function (c) {
      return c && c.componentName ? c.componentName.text : "";
    };

    // 2. How precisely did Google resolve the address?
    //    SUB_PREMISE / PREMISE / PREMISE_PROXIMITY -> an actual building was found.
    //    ROUTE / BLOCK / OTHER                     -> street level or worse.
    const BUILDING_LEVEL  = ["SUB_PREMISE", "PREMISE", "PREMISE_PROXIMITY"];
    const validationGran  = verdict.validationGranularity || "OTHER";
    const geocodeGran     = verdict.geocodeGranularity || "OTHER";
    const suspiciousFound = components.some(function (c) {
      return c.confirmationLevel === "UNCONFIRMED_AND_SUSPICIOUS";
    });
    const resolvedToBuilding =
      BUILDING_LEVEL.indexOf(validationGran) !== -1 ||
      (BUILDING_LEVEL.indexOf(geocodeGran) !== -1 && !suspiciousFound);

    const route    = bestOf("route");
    const number   = bestOf("street_number");
    const postal   = bestOf("postal_code", "postal_code_prefix");
    const locality = bestOf("locality", "postal_town", "sublocality",
                            "administrative_area_level_2", "administrative_area_level_1");
    const country  = bestOf("country");

    // 3. Google could not pin the address down to a building -> genuine problem.
    //    Pick the most useful message for the customer.
    if (!resolvedToBuilding) {
      if (validationGran === "ROUTE" || validationGran === "BLOCK" ||
          geocodeGran === "ROUTE" || geocodeGran === "BLOCK") {
        // Street exists, house number does not.
        return { valid: false, message: getErrorText("invalid_street_number") };
      }
      if (route && route.confirmationLevel === "UNCONFIRMED_AND_SUSPICIOUS") {
        return { valid: false, message: getErrorText("invalid_street") };
      }
      if (!route && !number) {
        return { valid: false, message: getErrorText("invalid_street") };
      }
      return { valid: false, message: getErrorText("invalid_address") };
    }

    // From here on Google DID find the building. Only reject when Google
    // contradicts what the customer typed.

    // 4. Street name -- only complain when Google flags it as suspicious.
    //    A missing route is expected for street-less rural addresses.
    if (route && !trusted(route)) {
      return { valid: false, message: getErrorText("invalid_street") };
    }

    // 5. House number -- same rule.
    if (number && !trusted(number)) {
      return { valid: false, message: getErrorText("invalid_street_number") };
    }

    // 6. Postal code -- check it exists and agrees with what was typed.
    if (postal && !trusted(postal)) {
      return { valid: false, message: getErrorText("postal_not_valid") };
    }
    const userZip   = norm(selectedZip);
    const googleZip = norm(textOf(postal));
    if (userZip && googleZip &&
        googleZip.indexOf(userZip) === -1 && userZip.indexOf(googleZip) === -1) {
      return { valid: false, message: getErrorText("postal_mismatch") };
    }

    // 7. City -- compare against EVERY locality-ish component Google returned.
    //    For "Slunj" Google returns the hamlet as the confirmed locality and the
    //    municipality as plausible; either one is an acceptable match.
    if (allOf("locality", "postal_town", "sublocality",
              "administrative_area_level_2", "administrative_area_level_1").length &&
        !trusted(locality)) {
      return { valid: false, message: getErrorText("city_mismatch") };
    }

    // 8. Country must match the dropdown.
    if (country && !trusted(country)) {
      return { valid: false, message: getErrorText("country_not_failed") };
    }
    // Overseas territories and dependencies legitimately geocode to their OWN
    // ISO code while the customer picks the parent country in the dropdown
    // (e.g. dropdown "FR" -> Guadeloupe returns "GP", "NL" -> Bonaire returns
    // "BQ", "DK" -> Greenland returns "GL"). Treat those as a match, otherwise
    // we would invent a brand-new false rejection.
    const TERRITORIES = {
      FR: ["GP", "MQ", "GF", "RE", "YT", "PM", "BL", "MF", "WF", "PF", "NC", "TF"],
      NL: ["AW", "CW", "SX", "BQ"],
      DK: ["FO", "GL"],
      FI: ["AX"],
      NO: ["SJ", "BV"],
      GB: ["GG", "JE", "IM", "GI", "FK", "SH", "VG", "AI", "MS", "KY", "TC", "BM", "PN", "GS", "IO"],
      US: ["PR", "VI", "GU", "AS", "MP", "UM"],
      AU: ["CX", "CC", "NF", "HM"],
      NZ: ["CK", "NU", "TK"],
      CN: ["HK", "MO"],
      ES: ["IC", "EA"]
    };
    const countryMatches = function (wanted, region) {
      if (!wanted || !region || wanted === region) return true;
      const kids = TERRITORIES[wanted] || [];
      if (kids.indexOf(region) !== -1) return true;
      // and the other way round (dropdown lists the territory itself)
      for (const parent in TERRITORIES) {
        if ((TERRITORIES[parent] || []).indexOf(wanted) !== -1 && parent === region) return true;
      }
      return false;
    };
    if (selectedCountry) {
      const wanted = norm(selectedCountry);
      const region = norm(addressObj.postalAddress && addressObj.postalAddress.regionCode);
      if (wanted.length === 2 && region.length === 2 && !countryMatches(wanted, region)) {
        return { valid: false, message: getErrorText("country_mismatch") };
      }
    }

    return { valid: true, message: "" };
  };

  validateAddressFields();

  showStep(1);
});